import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config";
import { useCart } from "../contexts/CartContext";
import "../styles/Products.css";

const SearchPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const query = params.get("q") || "";

  const [searchInput, setSearchInput] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toastMessage, setToastMessage] = useState("");

  const {
    addToCart,
    getItemQuantity,
    increaseQuantity,
    decreaseQuantity
  } = useCart();

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(""), 2000);
  };

  useEffect(() => {
    if (!query) {
      setLoading(false); // Evita mostrar "Buscando..." cuando no hay búsqueda
      return;
    }

    const fetchResults = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/products?q=${query}`);
        setResults(res.data.products || []);
      } catch (err) {
        console.error("Error al buscar productos:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [query]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchInput.trim()) {
      navigate(`/buscar?q=${encodeURIComponent(searchInput.trim())}`);
    }
  };

  return (
    <div className="products-page">
       <div className="category-header">
      <Link to="/" className="back-link">
        <i className="fas fa-arrow-left"></i>
      </Link>
      {query ? (
        <h1 className="category-title">Resultados para: "{query}"</h1>
      ) : (
        <form onSubmit={handleSearchSubmit} className="search-form">
          <input
            type="text"
            placeholder="Buscar productos..."
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            className="search-input"
          />
          <button type="submit" className="search-button">Buscar</button>
        </form>
      )}
      </div>


      {toastMessage && <div className="toast">{toastMessage}</div>}

      {loading ? (
        <div className="loading">Buscando productos...</div>
      ) : results.length === 0 && query ? (
        <p>No se encontraron productos.</p>
      ) : (
        <div className="product-grid">
          {results.map((product) => {
            const quantity = getItemQuantity(product.id);
            return (
              <div key={product.id} className="product-card">
                {product.image && (
                  <img
                    src={`${API_BASE_URL}${product.image}`}
                    alt={product.name}
                    className="product-image"
                  />
                )}
                <div className="product-details">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                  <p className="product-price">
                    Precio: ${product.price.toFixed(2)}
                  </p>

                  {quantity === 0 ? (
                    <button
                      className="add-to-cart-btn"
                      onClick={() => {
                        addToCart({
                          id: product.id,
                          name: product.name,
                          price: product.price,
                          image: product.image,
                        });
                        showToast(`${product.name} agregado al carrito ✅`);
                      }}
                    >
                      Agregar al carrito
                    </button>
                  ) : (
                    <div className="quantity-controls">
                      <button
                        onClick={() => {
                          decreaseQuantity(product.id);
                          showToast(`Cantidad de ${product.name} reducida`);
                        }}
                      >
                        -
                      </button>
                      <span className="quantity">{quantity}</span>
                      <button
                        onClick={() => {
                          increaseQuantity(product);
                          showToast(`Agregaste otra unidad de ${product.name} ✅`);
                        }}
                      >
                        +
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SearchPage;
